import * as React from 'react';
import { Input, InputProps } from '../../atoms/Input';
import Label from '../../atoms/Label';
import { Theme } from '../../utilities/theme';

type AdditionalProps = {
  label: string;
  theme?: Theme;
  required?: boolean;
  tooltip?: string;
  inline?: boolean;
};

type Props = InputProps & AdditionalProps;

export const LabelledInput = (props: Props) => {
  const name = props.tag;
  const { label, theme, required, tooltip, inline } = props;
  return (
    <div data-id="labelled-input-container">
      <Label
        inline={inline}
        htmlFor={name}
        required={required}
        label={label}
        theme={theme}
        tooltip={tooltip}
      >
        <Input {...props} />
      </Label>
    </div>
  );
};

export default LabelledInput;
